import { render } from "./SendMessageIcon.vue?vue&type=template&id=d5cc5d0e"
const script = {}

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/icons/SendMessageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5cc5d0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5cc5d0e', __exports__)) {
    console.log('reload')
    api.reload('d5cc5d0e', __exports__)
  }
  
  module.hot.accept("./SendMessageIcon.vue?vue&type=template&id=d5cc5d0e", () => {
    console.log('re-render')
    api.rerender('d5cc5d0e', render)
  })

}


export default __exports__